import type { FieldPolicy, Reference } from '@apollo/client';

type TeacherCoursesList = {
    courses: Reference[];
    isPriceVisible: boolean;
};

export const mergeCoursesList: FieldPolicy<TeacherCoursesList>['merge'] = (
    existing = { courses: [], isPriceVisible: false },
    incoming,
    { args },
) => {
    const offset = args?.offset ?? 0;
    const mergedCourses = existing.courses ? [...existing.courses] : [];

    for (let i = 0; i < incoming.courses.length; ++i) {
        mergedCourses[offset + i] = incoming.courses[i];
    }

    return {
        ...existing,
        ...incoming,
        courses: mergedCourses,
    };
};
